import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'

function Commenti() {
    const [commenti, setCommenti] = useState()
    const [dettagliCommento, setDettagliCommento] = useState()
    const [stato, setStato] = useState({ stato: 'notRead', stato2: 'notRead', color: 'red', titolo: 'Commenti non letti' })
    const [btnBlocca, setBtnBlocca] = useState({ stato: '', msg: '' })

    const bannerCommento = useRef()

    const grid = '23% 23% 23% 5% 25%'

    function modeChange() {
        if (stato.stato === 'notRead') {
            setStato({ stato: 'read', stato2: 'notRead', color: 'green', titolo: 'Tutti i commenti' })
        } else {
            setStato({ stato: 'notRead', stato2: 'notRead', color: 'red', titolo: 'Commenti non letti' })
        }
    }
    async function pressMessage(commento) {
        if (bannerCommento.current.style.top === '100%') {
            bannerCommento.current.style.top = '0'
            if (commento.statoXadmin === 'notRead') {
                const res = await axios.get(`/changeStatoCommento/${commento.id}`)
                if (res.data.message === 'success') {
                    document.getElementById('commento' + commento.id).style.display = 'none'
                }
            }
            // const res2 = await axios.get(`/getUser/${commento.idMittente}`)
            // if (res2.data.results.disabledCommentDaAdmin === 'true') {
            //     setBtnBlocca({ ...btnBlocca, stato: 'sblocca', msg: 'UTENTE CON COMMENTI BLOCCATI' })
            // } else {
            //     setBtnBlocca({ ...btnBlocca, stato: 'blocca', msg: '' })
            // }
        } else {
            bannerCommento.current.style.top = '100%'; return
        }
        setDettagliCommento(commento)
    }

    async function deleteCommento(idCommento) {
        try {
            const res = await axios.get(`/removeComment/${idCommento}`)
            if (res.data.message === 'success') {
                bannerCommento.current.style.top = '100%'
                document.getElementById('commento' + idCommento).style.display = 'none'
            }
        } catch (err) { console.log(err) }
    }

    async function blocca(idMittente) {
        if (btnBlocca.stato === 'blocca') { setBtnBlocca({ ...btnBlocca, stato: 'sblocca', msg: 'UTENTE CON CHAT BLOCCATA' }) } else {
            setBtnBlocca({ ...btnBlocca, stato: 'blocca', msg: '' })
        }
        try {
            const res = await axios.get(`/bloccaCommenti/${idMittente}/${btnBlocca.stato}`)
        } catch (err) { console.log(err) }

    }

    useEffect(() => {
        async function getCommenti() {
            const res = await axios.post('/getCommenti')
            setCommenti(res.data)
        }
        getCommenti()
    }, [])

    useEffect(() => { console.log(btnBlocca) }, [btnBlocca])
    return (<>
        <AuthProvider />
        <NavbarTopAdmin />
        <h2 style={{ margin: '4em 1em 1em 1em', color: stato.color, width: 'fit-content', display: 'inline-block' }}>{stato.titolo}</h2>
        <button onClick={modeChange}>Change</button>

        <div style={{ overflow: 'auto', height: '32em', width: '100%' }}>
            <div style={{
                display: 'grid', gridTemplateColumns: grid, gap: '5px', margin: '1em', fontSize: 'small', fontWeight: '700',
                position: 'sticky', top: '0'
            }}>
                <div>Data</div>
                <div>Mittente</div>
                <div>Destinatario</div>
                <div>ID</div>
                <div>Stato</div>
            </div>

            {commenti &&
                commenti.filter(item => item.statoXadmin === stato.stato || item.statoXadmin === stato.stato2).map
                    (commento => (
                        <span key={commento.id}>
                            <div style={{ display: 'grid', gridTemplateColumns: grid, gap: '5px', margin: '1em', fontSize: 'small', cursor: 'pointer' }}
                                onClick={() => { pressMessage(commento) }} id={`commento${commento.id}`}>
                                <div>{new Date(commento.created_at).toISOString().slice(0, 10).split("-").reverse().join("-")}</div>
                                {commento.nomeMittente ? <div>{commento.nomeMittente}</div> : <div>Anonimo</div>}
                                {commento.nomeDestinatario ? <div>{commento.nomeDestinatario}</div> : <div>Anonimo</div>}
                                <div>{commento.id}</div>
                                <div>{commento.statoXadmin}</div>
                            </div>
                        </span>
                    ))
            }
        </div>
        {/* ----------------------- BANNER COMMENTO ------------------------- */}
        <div ref={bannerCommento} style={{
            position: 'fixed', top: '100%', left: '0', right: '0', width: '100%', height: '100%', transition: '.2s ease-in',
            border: '1px solid lightcyan', zIndex: '1', backgroundColor: 'whitesmoke'
        }}>
            <div style={{ padding: '.5em 1.5em', backgroundColor: 'whitesmoke' }}>
                <span onClick={() => { pressMessage(dettagliCommento.id) }} style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>◁
                </span>
                <h2 style={{ display: 'inline' }}>Dettagli commento</h2>

                {btnBlocca.msg && <p style={{ color: 'red', marginLeft: '4.5em' }}><u>{btnBlocca.msg}</u></p>}

            </div> <hr style={{ borderTop: '2px solid black' }} />

            {dettagliCommento &&
                <div className='container'>
                    {dettagliCommento.fotoMittente ?
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${dettagliCommento.fotoMittente}`} style={{ borderRadius: '50%', width: '48px', height: '48px', marginTop: '.5em' }} alt='' /> :
                        <img src={require('../userNotAuth/image/icons8-impostazioni-amministratore-maschio-32.png')} alt='' />
                    }
                    {dettagliCommento.nomeMittente && <span style={{ marginLeft: '1em' }}>{dettagliCommento.nomeMittente}</span>}
                    <div className='mt-3'>
                        <i>{dettagliCommento.messaggio}</i>
                    </div>
                </div>
            }
            <hr />
            <div style={{ margin: '2em' }}>
                <button className='btn btn-danger' onClick={() => { deleteCommento(dettagliCommento.id) }}>Elimina</button>
                {btnBlocca.stato &&
                    <button style={{ marginLeft: '1em' }} className='btn btn-dark' onClick={() => { blocca(dettagliCommento.idMittente) }}>{btnBlocca.stato}</button>
                }
            </div>
        </div>
        <NavbarBottomAdmin />
    </>
    )
}
export default Commenti